import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { BUTTON_TEXT } from '../consts.jsx'
import Error from '../Error';
import "./Button.css"
class Button extends Component {   
  getClassName = () => this.props.content?.toLowerCase ? this.props.content?.toLowerCase().split(' ').join('-') : ""
  render() {
    const onClick =(e) => this.props.onClick && this.props.onClick(e)
    return (
      <div className={`cc-button-wrapper ${this.props.className}${this.props.loading ? " loading" : ""}` }>
        <Error text={this.props.errorMessage}/>
        <button className={`cc-button ${this.props.disabled ? "disable " : ""}${this.getClassName()}`} onClick={onClick}>
          {this.props.loading && <FontAwesomeIcon icon={faRefresh} spin={true} />}
          <span className="auth-button-text">{this.props.content}</span>
        </button>          
      </div>
    );
  }
}

Button.propTypes = {
  loading: PropTypes.bool,
  errorMessage: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  className: PropTypes.string
};

Button.defaultProps = {
  content: BUTTON_TEXT.ACTIVATE,
  disabled: false,
  className: ''
};

export default Button;